<template>
  <div class="pageContainer">
    <div class="container mt-5">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card loginCard">
            <img src="../../../assets/images/logo.png" style="width: 35%;margin:auto; margin-top:20px;"/>
            <div>
              <h4 style="display: inline-block; margin-right: 20%">إعادة تعيين كلمة المرور</h4>
              <a
                href="/login"
                class="text-info"
                style="margin-right: 15%; font-size: 30px"
                ><i class="fas fa-arrow-circle-left"></i
              ></a>
            </div>
            <div class="card-body">
              <form @submit.prevent="resetPassword">
                <div class="form-group">
                  <label for="password">كلمة المرور</label>
                  <input type="password" class="form-control" id="password" v-model="password" />
                  <div class="text-danger">{{ errors.password }}</div>
                </div>
                <div class="form-group">
                  <label for="confirmPassword">تأكيد كلمة المرور</label>
                  <input type="password" class="form-control" id="confirmPassword" v-model="confirmPassword" />
                  <div class="text-danger">{{ errors.confirmPassword }}</div>
                </div>
                <button type="submit" class="btn btn-primary">إرسال</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </template>
  
  <script>
  import Axios from "../../../Axios";
  import Swal from "sweetalert2";
  import * as yup from "yup";
  
  const forgotPasswordSchema = yup.object().shape({
    password: yup.string().required("يرجى إدخال كلمة المرور"),
    confirmPassword: yup.string().required("يرجى إدخال كلمة المرور"),
  });
  
  export default {
    data() {
      return {
        password: "",
        confirmPassword: "",
        errors: {},
      };
    },
    methods: {
      resetPassword() {
        const { password } = this;
        const { confirmPassword } = this;
        const resetToken = this.$route.params.token;
        forgotPasswordSchema
          .validate({ password, confirmPassword }, { abortEarly: false })
          .then(() => {
            Axios
            .patch("/resetpassword/"+resetToken, {
              password: password,
              confirmPassword: confirmPassword,
            })
            .then((response) => {
              // console.log(response.data);
              Swal.fire({
              icon: "success",
              title: "تم تجديد كلمة المرور!",
              confirmButtonText: "حسناً",
            });
            })
            
          })
          .catch((errors) => {
            // Yup validation errors
            const errorMessages = {};
            errors.inner.forEach((error) => {
              errorMessages[error.path] = error.message;
            });
            this.errors = errorMessages;
          });
      },
    },
  };
  </script>
  
  <style></style>
  